import { outputIndexesGroupingTypesEnum } from "constants/cargorunIndexes";
import moment from "moment";
import "moment/locale/ru";
import type { OutputIndexesGroupingType } from "sources/cargorunIndexes";

/** Formats an index aggregation bucket for its chart axis or tooltip. */
export function formatIndexDate(value: string, groupingType: OutputIndexesGroupingType, compact = false): string {
    const start = moment(value, "YYYY-MM-DD", true).locale("ru");
    if (groupingType === outputIndexesGroupingTypesEnum.ByDays) {
        return start.format(compact ? "D MMM" : "D MMMM YYYY");
    }
    if (groupingType === outputIndexesGroupingTypesEnum.ByMonths) {
        const label = start.format(compact ? "MMM YYYY" : "MMMM YYYY");
        return label.charAt(0).toUpperCase() + label.slice(1);
    }

    const end = start.clone().add(6, "days");
    if (start.isSame(end, "month")) {
        return `${start.format("D")}–${end.format(compact ? "D MMM" : "D MMMM YYYY")}`;
    }
    const startMask = start.isSame(end, "year") || compact ? "D MMMM" : "D MMMM YYYY";
    return `${start.format(startMask)} – ${end.format(compact ? "D MMM" : "D MMMM YYYY")}`;
}
